module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-LightOblique.8476f000.woff";